/**
 * @generated SignedSource<<b49316331300bc129fb8d73e2bea2b99>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CartChannel = "businessshop" | "personalshop" | "personalss" | "sparkdigitalshop";
export type ChangePlanButtonMutation$variables = {
  channel: CartChannel;
  offerId: string;
};
export type ChangePlanButtonMutation$data = {
  readonly updateMobileChangePlanUser: {
    readonly accounts: ReadonlyArray<{
      readonly accountNumber: string;
      readonly firstName: string | null;
      readonly lastName: string | null;
    }> | null;
    readonly eligibleLines: ReadonlyArray<{
      readonly accountName: string | null;
      readonly accountNumber: string | null;
      readonly lineNumber: string;
      readonly offerId: string;
      readonly offerName: string;
    }> | null;
    readonly errorMessage: string | null;
    readonly errorReason: string | null;
    readonly redirectPath: string | null;
    readonly shouldOpenNoAccountModal: boolean;
    readonly shouldShowErrorSnackbar: boolean;
  };
};
export type ChangePlanButtonMutation = {
  response: ChangePlanButtonMutation$data;
  variables: ChangePlanButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "channel"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "offerId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "accountNumber",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "channel",
        "variableName": "channel"
      },
      {
        "kind": "Literal",
        "name": "enableAccountSelector",
        "value": true
      },
      {
        "kind": "Variable",
        "name": "offerId",
        "variableName": "offerId"
      }
    ],
    "concreteType": "UpdateMobileChangePlanUserResponse",
    "kind": "LinkedField",
    "name": "updateMobileChangePlanUser",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "redirectPath",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shouldShowErrorSnackbar",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "shouldOpenNoAccountModal",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorReason",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errorMessage",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "IfpEligibleLine",
        "kind": "LinkedField",
        "name": "eligibleLines",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "accountName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lineNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "offerName",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Account",
        "kind": "LinkedField",
        "name": "accounts",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ChangePlanButtonMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ChangePlanButtonMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "44ed0203ce6bca80baebe492cafe7621",
    "id": null,
    "metadata": {},
    "name": "ChangePlanButtonMutation",
    "operationKind": "mutation",
    "text": "mutation ChangePlanButtonMutation(\n  $channel: CartChannel!\n  $offerId: String!\n) {\n  updateMobileChangePlanUser(channel: $channel, offerId: $offerId, enableAccountSelector: true) {\n    redirectPath\n    shouldShowErrorSnackbar\n    shouldOpenNoAccountModal\n    errorReason\n    errorMessage\n    eligibleLines {\n      accountNumber\n      accountName\n      lineNumber\n      offerId\n      offerName\n    }\n    accounts {\n      accountNumber\n      firstName\n      lastName\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f09f8e18e7940c854926f855b349d712";

export default node;
